import { render, staticRenderFns } from "./AccountDocuments.vue?vue&type=template&id=822ee17e&scoped=true&"
import script from "./AccountDocuments.vue?vue&type=script&lang=js&"
export * from "./AccountDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AccountDocuments.vue?vue&type=style&index=0&id=822ee17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822ee17e",
  null
  
)

export default component.exports